import apiClient from "../api";

const FORUM_HEADER_PUBLIC = "/forum-page-header/public";
const QUESTIONS_PUBLIC = "/questions/public";

/** ForumPageHeader schema (forum_page_header) – title, description */
export type ForumHeader = { title: string; description: string };

/** Question schema (questions) – карт харуулахад ашиглах талбарууд: id, title, link, image */
export type ForumCard = { id: number; title: string; link: string | null; image: string | null };

export const forumApi = {
  /** ForumPageHeader-ээс гарчиг, тайлбар татах */
  getHeader: () =>
    apiClient.get<{ success: boolean; data: ForumHeader }>(FORUM_HEADER_PUBLIC),

  /** Question-ийн идэвхтэй жагсаалт (картууд) татах */
  getQuestions: () =>
    apiClient.get<{ success: boolean; data: ForumCard[] }>(QUESTIONS_PUBLIC),
};

export default forumApi;
